export enum OrderSettingsNameValuePairEnum {
    ORDER_CONFIRMATION_EMAIL_BCC = 'ORDER_CONFIRMATION_EMAIL_BCC',
    ORDER_NOTIFICATION_EMAIL_FROM = 'ORDER_NOTIFICATION_EMAIL_FROM',
    ORDER_NOTIFICATION_EMAIL_REPLY_TO = 'ORDER_NOTIFICATION_EMAIL_REPLY_TO'
}
